// extracted by mini-css-extract-plugin
module.exports = {"prices":"UqnnNN","outOfStock":"zOeYx3","priceBeforeDiscount":"DlHYV3","priceFrom":"WuSRvG","priceToPay":"cfpn1d","basePrice":"lNKT8J","priceBreakdown":"eIXtWz"};